import { Component, Inject, forwardRef, Optional, Input } from '@angular/core';
// import {
//   TypedBaseWidget,
//   NgAisInstantSearch,
//   NgAisIndex
// } from 'angular-instantsearch';

import connectNumericMenu, {
  NumericMenuWidgetDescription,
  NumericMenuConnectorParams,
  NumericMenuConnectorParamsItem
} from 'instantsearch.js/es/connectors/numeric-menu/connectNumericMenu';
import { BaseWidget } from '../base-widget';
import { MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu';
import { NumericMenuItem } from '../search.types';

interface NumericMenuState {
  items: NumericMenuItem[];
  refine: (refinement: string) => void;
}

@Component({
  selector: 'app-numeric-menu-select',
  templateUrl: './numeric-menu-select.component.html',
  styleUrls: ['./numeric-menu-select.component.scss']
})
export class NumericMenuSelectComponent extends BaseWidget<NumericMenuState> {
  @Input()
  attribute: string | undefined;

  @Input()
  items: NumericMenuConnectorParamsItem[];

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  createWidget() {
    return connectNumericMenu(renderState => {
      this.updateState({
        items: renderState.items,
        refine: renderState.refine
      });
    })({
      attribute: this.attribute,
      items: this.items
    });
  }
}
